"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "capodrise": {
    "b034a646": [{
      "hkey": "f941454a",
      "slug": "capodrise",
      "name": "Capodrise",
      "primary": true,
      "skipSearch": false
    }],
    "acquedotto-nocelle": [{
      "hkey": "f941454a",
      "slug": "capodrise",
      "name": "Capodrise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a5f58996": [{
      "hkey": "f941454a",
      "slug": "capodrise",
      "name": "Capodrise",
      "primary": true,
      "skipSearch": false
    }],
    "botteghe": [{
      "hkey": "f941454a",
      "slug": "capodrise",
      "name": "Capodrise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2b22fd0e": [{
      "hkey": "f941454a",
      "slug": "capodrise",
      "name": "Capodrise",
      "primary": true,
      "skipSearch": false
    }],
    "marte": [{
      "hkey": "f941454a",
      "slug": "capodrise",
      "name": "Capodrise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f19f8aa3": [{
      "hkey": "f941454a",
      "slug": "capodrise",
      "name": "Capodrise",
      "primary": true,
      "skipSearch": false
    }],
    "musicile": [{
      "hkey": "f941454a",
      "slug": "capodrise",
      "name": "Capodrise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8758e7c9": [{
      "hkey": "f941454a",
      "slug": "capodrise",
      "name": "Capodrise",
      "primary": true,
      "skipSearch": false
    }],
    "olivo": [{
      "hkey": "f941454a",
      "slug": "capodrise",
      "name": "Capodrise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e7d62035": [{
      "hkey": "f941454a",
      "slug": "capodrise",
      "name": "Capodrise",
      "primary": true,
      "skipSearch": false
    }],
    "pagani": [{
      "hkey": "f941454a",
      "slug": "capodrise",
      "name": "Capodrise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5788ec74": [{
      "hkey": "f941454a",
      "slug": "capodrise",
      "name": "Capodrise",
      "primary": true,
      "skipSearch": false
    }],
    "san-donato": [{
      "hkey": "f941454a",
      "slug": "capodrise",
      "name": "Capodrise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;